import { gql } from '@apollo/client';

export const activityTotalsFragment = gql`
  fragment ActivityTotals on Page {
    id
    totals {
      timeline {
        measurementDomain
        amounts {
          unit
          value
        }
      }
      displayOptions
      primaryMeasurementType
    }
  }
`;
